import { render, staticRenderFns } from "./ModalMedicine2.vue?vue&type=template&id=2e04250e&"
import script from "./ModalMedicine2.vue?vue&type=script&lang=js&"
export * from "./ModalMedicine2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports